var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"stroke":"none","cx":"10","cy":"50","r":"10","key":0},React.createElement("animate",{"attributeName":"opacity","dur":"1s","values":"0;1;0","repeatCount":"indefinite","begin":"0.1"})),React.createElement("circle",{"stroke":"none","cx":"44","cy":"50","r":"10","key":1},React.createElement("animate",{"attributeName":"opacity","dur":"1s","values":"0;1;0","repeatCount":"indefinite","begin":"0.2"})),React.createElement("circle",{"stroke":"none","cx":"78","cy":"50","r":"10","key":2},React.createElement("animate",{"attributeName":"opacity","dur":"1s","values":"0;1;0","repeatCount":"indefinite","begin":"0.3"}))]);
}

Loader.defaultProps = {"x":"0","y":"0","viewBox":"0 0 100 100"};

module.exports = Loader;

Loader.default = Loader;
